import React, { useState, useEffect, useRef } from 'react'
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai'
import proto1 from '../../images/ticket/proto1.png'
import proto2 from '../../images/ticket/proto2.png'
import proto3 from '../../images/ticket/proto3.png'
import proto4 from '../../images/ticket/proto4.png'
import proto5 from '../../images/ticket/proto5.png'
import proto6 from '../../images/ticket/proto6.png'
import proto7 from '../../images/ticket/proto7.png'
const img = [
  proto1,
  proto2,
  proto3,
  proto4,
  proto5,
  proto6,
  proto7
]

let count = 0
let slideInterval

export default function Ticket() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const handleNext = () => {
    count = (count + 1) % img.length
    setCurrentIndex(count)
    sliderRef.current.classList.add('fade-anim')
  }
  const handlePrev = () => {
    const productLength = img.length
    count = (currentIndex + productLength - 1) % img.length
    setCurrentIndex(count)
    sliderRef.current.classList.add('fade-anim')
  }
  const sliderRef = useRef()
  const removeAnimation = () => {
    sliderRef.current.classList.remove('fade-anim')
  }
  useEffect(() => {
    sliderRef.current.addEventListener('animationend', removeAnimation)
    sliderRef.current.addEventListener('mouseenter', pauseSlider)
    sliderRef.current.addEventListener('mouseleave', startSlider)
    startSlider()
    return () => {
      pauseSlider()
    }
  }, [])

  const startSlider = () => {
    slideInterval = setInterval(() => {
      handleNext()
    }, 4000)
  }

  const pauseSlider = () => {
    clearInterval(slideInterval)
  }
  return (
    <div className="md:flex items-center">
      <div className="md:hidden md:w-1/2">
        <h2 className="text-gray-600 dark:text-[#FFE332] text-4xl text-center lg:text-6xl my-font uppercase px-4 md:pl-10">
        Ticket Rising Mobile Application Wireframe
        </h2>
      </div>
      <div className="md:w-1/2">
        <div ref={sliderRef} className="select-none relative">
          <div className="flex">
            <div className="w-full">
              <img src={img[currentIndex]} className="h-auto w-full px-10 md:px-28 lg:px-36" />
            </div>
          </div>
          <div className="absolute top-1/2 transform -translate-y-1/2 flex justify-between items-center w-full px-2 md:px-6 lg:px-10">
            <button onClick={handlePrev} className="bg-gray-600 dark:bg-[#FFE332] rounded-full p-1 md:p-2 dark:shadow dark:shadow-[#FFE332]">
              <AiOutlineArrowLeft size={20} className="text-white dark:text-black" />
            </button>
            <button onClick={handleNext} className="bg-gray-600 dark:bg-[#FFE332] rounded-full p-1 md:p-2 dark:shadow dark:shadow-[#FFE332]">
              <AiOutlineArrowRight size={20} className="text-white dark:text-black" />
            </button>
          </div>
        </div>
      </div>
      <div className="hidden md:block w-1/2">
        <h2 className="text-gray-600 dark:text-[#FFE332] text-4xl text-center lg:text-6xl my-font uppercase px-4 md:pl-10">
          Ticket Rising Mobile Application Wireframe
        </h2>
      </div>
    </div>
  )
}
